import React from 'react';
import { Space, Tag } from 'antd';
import dayjs from 'dayjs';
import { PreviewItem } from '../../../../lib/api/settlementDateAdjustment';
import { StyledDueDatePicker } from './styles';

type Props = {
  row: PreviewItem;
  /**
   * 운영자가 직접 지정한 dueDate(YYYY-MM-DD). undefined 면 서버 자동 계산값 사용.
   */
  override: string | undefined;
  /**
   * DatePicker 변경 핸들러. dueDate 가 null 이면 override 제거(자동 계산값 복원).
   */
  onChange: (settlementItemId: number, dueDate: string | null) => void;
};

/**
 * Preview 모달의 "변경 후 정산 예정일" 셀.
 *
 * 운영자가 자동 계산값과 다른 날짜로 바꾸면 진한 보더 + "수동" 배지로 강조.
 * 비우면(allowClear) override 가 제거되고 자동 계산값 복원.
 * 영업일/baseDate 역전 검증은 서버가 execute 시점에 fail-fast 로 강제한다.
 */
export const AfterDueDateCell = ({ row, override, onChange }: Props): React.JSX.Element => {
  const isOverridden = override !== undefined;
  const displayValue = isOverridden ? override : row.afterDueDate;

  return (
    <Space size={4}>
      <StyledDueDatePicker
        size="small"
        allowClear
        $isOverridden={isOverridden}
        value={displayValue ? dayjs(displayValue) : null}
        // styled(DatePicker) 가 antd 의 generic onChange 시그니처를 잃어 contract 가
        // (date: unknown, ...) => void 가 됨. 매개변수 contravariance 규칙으로 Dayjs 는
        // unknown 에 호환 안 되므로 핸들러는 unknown 으로 받고 dayjs.isDayjs 로 narrow.
        onChange={(date) =>
          onChange(
            row.id,
            dayjs.isDayjs(date) ? date.format('YYYY-MM-DD') : null,
          )
        }
      />
      {isOverridden && <Tag color="blue">수동</Tag>}
    </Space>
  );
};
